import { createIcon } from '@chakra-ui/icons'

const XMLIcon = createIcon({
  viewBox: '0 0 800 1000',
  path: (
    <>
      <path
        d="M27.81 996C14.68 996 4 985.32 4 972.19V364.04h792v605.64c0 14.52-11.81 26.32-26.32 26.32H27.81Z"
        fill="#fff"
      />
      <path
        d="M792 368.04v601.64c0 12.31-10.01 22.32-22.32 22.32H27.81C16.88 992 8 983.11 8 972.19V368.04h784m8-8H0v612.15C0 987.55 12.45 1000 27.81 1000h741.87c16.75 0 30.32-13.58 30.32-30.32V360.04Z"
        fill="#e9ebf1"
      />
      <path
        d="M800 369.45H0V30.12C0 13.49 13.49 0 30.12 0h540.14l125.47 111.83L800 204.36v165.09Z"
        fill="#f90"
      />
      <path
        d="M570.26 0v153.81c0 27.92 22.63 50.55 50.55 50.55H800L570.26 0Z"
        opacity=".5"
        fill="#fff"
      />
      <path
        d="m269.88 574.14-102.67 96.07 102.67 101M530.12 771.21l102.67-96.07-102.67-101M464.28 497.05 335.72 848.3"
        fill="none"
        stroke="#e9ebf1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="30px"
      />
      <text
        transform="translate(57.7 245.05)"
        fontFamily="Roboto-Regular,Roboto"
        fontSize="150px"
        fill="#fff"
      >
        <tspan x="0" y="0">
          XML
        </tspan>
      </text>
    </>
  ),
})

export default XMLIcon
